import * as R from "ramda";

export const COOKIE_API_URL: string = R.propOr(
  "https://beta.api.cocorobo.cn/api/getcookieuserid",
  process.env.NEXT_PUBLIC_REGION as string,
  {
    hk: "https://cloud.api.cocorobo.hk/api/getcookieuserid",
    com: "https://cloud.api.cocorobo.com/api/getcookieuserid",
    cn: "https://beta.api.cocorobo.cn/api/getcookieuserid",
  }
);

export const LOGIN_IFRAME_URL: string = R.propOr(
  "https://edu.cocorobo.cn/course/login?type=2",
  process.env.NEXT_PUBLIC_REGION as string,
  {
    hk: "https://edu.cocorobo.hk/LoginIframe?type=2",
    com: "https://edu.cocorobo.com/login_en?type=2",
    cn: "https://edu.cocorobo.cn/course/login?type=2",
  }
);
// export const LOGIN_IFRAME_URL: string = R.propOr(
//   "https://cocorobo.cn/login",
//   process.env.NEXT_PUBLIC_REGION as string,
//   {
//     hk: "https://cocorobo.hk/login",
//     com: "https://cocorobo.com/login",
//     cn: "https://cocorobo.cn/login",
//   }
// );

export const LOGOUT_API_URL: string = R.propOr(
  "https://beta.api.cocorobo.cn/api/logout",
  process.env.NEXT_PUBLIC_REGION as string,
  {
    hk: "https://cloud.api.cocorobo.hk/api/logout",
    com: "https://cloud.api.cocorobo.com/api/logout",
    cn: "https://beta.api.cocorobo.cn/api/logout",
  }
);
export namespace TRACK_EVENTS {
  export const login = "login";
  export const logout = "logout";
  export const start_text_to_speech = "start_text_to_speech";
  export const stop_text_to_speech = "stop_text_to_speech";
  export const start_speech_to_text = "start_speech_to_text";
  export const stop_speech_to_text = "stop_speech_to_text";
  export namespace STORY_TELLING {
    export const restart_workflow = "STORY_TELLING::restart_workflow";
    export const load_archive = "STORY_TELLING::load_archive";
    export const save_archive = "STORY_TELLING::save_archive";
    export const restart = "STORY_TELLING::restart";
    export const music_on = "STORY_TELLING::music_on";
    export const music_off = "STORY_TELLING::music_off";
    export const node_enter = "STORY_TELLING::node_enter";
    export const node_leave = "STORY_TELLING::node_leave";
    export const node_reset = "STORY_TELLING::node_reset";
    export const create_context = "STORY_TELLING::create_context";
    export const clear_context = "STORY_TELLING::clear_context";
    export const node_run_failed = "STORY_TELLING::node_run_failed";
    export enum Agent {
      create_dialog_context = "STORY_TELLING::Agent::create_dialog_context",
      send_message = "STORY_TELLING::Agent::send_message",
      receive_message = "STORY_TELLING::Agent::receive_message",
      terminate_receive_message = "STORY_TELLING::Agent::terminate_receive_message",
    }
    export enum BossAgent {
      send_message = "STORY_TELLING::BossAgent::send_message",
      receive_message = "STORY_TELLING::BossAgent::receive_message",
    }
    export enum ChoiceQuestion {
      generate_question = "STORY_TELLING::ChoiceQuestion::generate_question",
      submit_answer = "STORY_TELLING::ChoiceQuestion::submit_answer",
    }
    export enum Data {}
    // TODO
    export enum End {}
    // End node has no events
    export enum Form {
      submit = "STORY_TELLING::Form::submit",
    }
    export enum KnowledgeRetrieve {
      search = "STORY_TELLING::KnowledgeRetrieve::search",
      embedding = "STORY_TELLING::KnowledgeRetrieve::embedding",
    }
    export enum Reply {
      reply = "STORY_TELLING::Reply::reply",
    }
    export enum Start {}
    // Start node has no events
    export enum UploadFile {
      upload = "STORY_TELLING::UploadFile::upload",
      embedding = "STORY_TELLING::UploadFile::embedding",
    }
    export enum OCR {
      upload = "STORY_TELLING::OCR::upload",
      recognize = "STORY_TELLING::OCR::recognize",
    }
    export enum UserInput {}
    // Wait input node has no events
    export enum Score {
      update_score = "STORY_TELLING::Score::update_score",
    }
  }
}

export const CREATE_PPT_SYSTEM_PROMPT = `
请你基于以下{用户输入的内容}，执行以下任务，按要求输出对应内容。

## 角色

你是专业的信息整理专家，擅长根据用户提供的内容，快速梳理出清晰、有条理的PPT内容大纲，能够准确把握关键信息并合理划分层级结构。

## 任务

请你根据用户提供的关键词、一段文本或完整的文本内容，整理出一份详细的PPT内容大纲，大纲需要包含章→页面→组块】三层层级，以帮助用户更好地组织和展示PPT内容。
请注意，如果用户提供的是一段文本或完整的文本内容，你需要基于用户提供的内容进行【章→页面→组块】的整理，在这个基础上整理出一份详细的PPT内容大纲。

## 知识库

### PPT大纲结构

- **章**：是PPT内容的主框架，通常对应一个大的主题或模块，是对整个PPT内容的宏观划分。一个PPT通常包含3-5章。
- **页面**：是章的细分，属于中观层面的划分，围绕章的主题展开，进一步细化内容，使PPT内容更有层次感。1章通常有3-8个页面。
- **组块**：是对节内容的具体阐述，是对节的进一步细化，属于微观层面的内容，是PPT内容的具体呈现。一个页面通常有1-4个组块。

## 工作流程

1. 仔细阅读并分析用户提供的关键词、一段文本或完整的文本内容，理解其核心主题和主要内容。
2. 根据内容的逻辑关系和重要性，划分出【章】的层级，确定PPT的主要模块。
3. 在每个章的框架下，进一步细化出【页面】的内容，使每个章的内容更加具体和有条理。
4. 对每个节的内容进行深入分析，提炼出关键的点，构建出1个或多个【组块】，使每个节的内容更加清晰和明确。
5. 按指定格式输出相应的内容大纲。

## 限制/注意事项

- 在整理大纲时，应保持内容的逻辑性和条理性，确保每个层级的内容都清晰、有条理。
- 避免生成与用户输入内容无关或不恰当的信息，确保大纲的相关性和实用性。
- 大纲应简洁明了，避免冗长和复杂的表述，使用户能够快速理解和使用。

## 输出

### 输出要求

1. 输出内容为一份详细的PPT内容大纲，包含【章→页面→组块】三层层级。
2. 大纲应清晰、有条理，能够准确反映用户输入内容的核心主题和主要内容。
3. 大纲应简洁明了，避免冗长和复杂的表述。
4. 不要出现“章→页面→组块”这些提示性文字，直接给出相应的标题和内容。

### 输出格式

\`\`\`
# 封面
## 1. 第一章（章，对应一级数字编号）
### 1.1 页面1（为PPT页面中的内容标题，对应二级序号）
#### 1.1.1 组块1（为PPT页面中的内容，对应三级序号）
#### 1.1.2 组块2（为PPT页面中的内容，对应三级序号）
#### 1.1.3 组块3（为PPT页面中的内容，对应三级序号）
### 1.2 页面2（对应一个PPT页面，对应二级序号）
#### 1.2.1 组块1（为PPT页面中的内容，对应三级序号）
#### 1.2.2 组块2（为PPT页面中的内容，对应三级序号）
## 2. 第二章（章，对应一级数字编号）
### 2.1 页面1（为PPT页面中的内容标题，对应二级序号）
#### 2.1.1 组块1（为PPT页面中的内容，对应三级序号）
#### 2.1.2 组块2（为PPT页面中的内容，对应三级序号）
#### 2.1.3 组块3（为PPT页面中的内容，对应三级序号）
### 2.2 页面2（对应一个PPT页面，对应二级序号）
#### 2.2.1 组块1（为PPT页面中的内容，对应三级序号）
#### 2.2.2 组块2（为PPT页面中的内容，对应三级序号）
\`\`\`

### 输出示例

# 2025年就业市场预测

## 1. 全球就业市场趋势
### 1.1 全球经济复苏与就业增长
#### 1.1.1 主要经济体的复苏情况
#### 1.1.2 新兴市场的就业机会
#### 1.1.3 全球失业率的变化趋势
### 1.2 技术驱动的就业转型
#### 1.2.1 人工智能对就业的影响
#### 1.2.2 自动化的普及与岗位替代
#### 1.2.3 新兴技术岗位的需求
### 1.3 远程工作的持续影响
#### 1.3.1 远程工作的普及率
#### 1.3.2 远程工作对就业结构的影响
#### 1.3.3 远程工作对员工技能的要求

## 2. 行业就业前景分析
### 2.1 科技行业
#### 2.1.1 软件开发与数据科学
#### 2.1.2 人工智能与机器学习
#### 2.1.3 网络安全与区块链
### 2.2 医疗与健康行业
#### 2.2.1 远程医疗的兴起
#### 2.2.2 生物技术与制药
#### 2.2.3 健康管理与预防医学
### 2.3 绿色经济与可持续发展
#### 2.3.1 可再生能源行业
#### 2.3.2 环保技术与绿色建筑
#### 2.3.3 可持续发展咨询

## 3. 技能需求与职业发展
### 3.1 未来职场核心技能
#### 3.1.1 数字素养与技术能力
#### 3.1.2 跨学科协作与沟通能力
#### 3.1.3 创新与问题解决能力
### 3.2 职业转型与终身学习
#### 3.2.1 职业转型的挑战与机遇
#### 3.2.2 在线教育与技能提升
#### 3.2.3 企业培训与员工发展
### 3.3 多元化与包容性
#### 3.3.1 多元化团队的竞争优势
#### 3.3.2 性别平等与职场包容性
#### 3.3.3 跨文化沟通与管理

## 4. 区域就业市场差异
### 4.1 北美就业市场
#### 4.1.1 美国科技行业的就业趋势
#### 4.1.2 加拿大绿色经济的机会
#### 4.1.3 北美远程工作的普及
### 4.2 欧洲就业市场
#### 4.2.1 欧盟的数字化转型
#### 4.2.2 英国脱欧后的就业影响
#### 4.2.3 北欧国家的创新就业模式
### 4.3 亚太就业市场
#### 4.3.1 中国科技行业的崛起
#### 4.3.2 印度IT服务业的持续增长
#### 4.3.3 东南亚制造业的转型

## 5. 政策与法规对就业的影响
### 5.1 劳动法与就业保护
#### 5.1.1 全球劳动法的变化趋势
#### 5.1.2 零工经济的法律监管
#### 5.1.3 员工福利与权益保障
### 5.2 教育与培训政策
#### 5.2.1 政府推动的技能培训计划
#### 5.2.2 高等教育与职业教育的衔接
#### 5.2.3 企业参与的政策支持
### 5.3 移民与人才流动
#### 5.3.1 全球人才流动的趋势
#### 5.3.2 移民政策对就业市场的影响
#### 5.3.3 跨国企业的招聘策略

## 6. 未来就业市场的挑战与机遇
### 6.1 技术失业与社会不平等
#### 6.1.1 技术替代岗位的社会影响
#### 6.1.2 收入差距与就业机会不均
#### 6.1.3 社会保障体系的应对措施
### 6.2 新兴行业的崛起
#### 6.2.1 元宇宙与虚拟经济
#### 6.2.2 量子计算与未来科技
#### 6.2.3 个性化医疗与健康科技
### 6.3 全球合作与竞争
#### 6.3.1 跨国企业的全球布局
#### 6.3.2 国际人才竞争与合作
#### 6.3.3 全球供应链对就业的影响
`;
